export const get = async (endpoint) => {
  const response = await fetch(`${process.env.VUE_APP_BASE_API_URL}${endpoint}`)

  if (!response.ok) {
    return { error: response.error }
  }

  return { response: await response.json() }
}
